import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { fetchResourcesGeoJSON } from '@/components/field-view-next/composables/fetchResourcesGeoJSON'
import type { ResourcesGeoJSONQuery } from '@ironsight/types'
import { useJobFilterStore } from '../JobsFilterStore'

export function useResourcesGeoJSON() {
  const legacyJobStore = useJobFilterStore()

  const queryParams = computed(() => {
    return {
      resourceTypeIds:
        legacyJobStore.selectedResourceTypes.length > 0
          ? [...legacyJobStore.selectedResourceTypes]
          : undefined,
      ownerIds:
        legacyJobStore.selectedServiceProviders.length > 0
          ? [...legacyJobStore.selectedServiceProviders]
          : undefined,
      divisionIds:
        legacyJobStore.selectedDivisions.length > 0
          ? [...legacyJobStore.selectedDivisions]
          : undefined,
    } as ResourcesGeoJSONQuery
  })

  return useQuery({
    queryKey: ['resources-geojson', queryParams],
    placeholderData: {
      type: 'FeatureCollection',
      features: [],
    },
    queryFn: ({ signal }) => fetchResourcesGeoJSON(queryParams.value, signal),
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
    staleTime: 25000,
  })
}
